import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';


@Component({
  selector: 'app-viewservice',
  templateUrl: './viewservice.component.html',
  styleUrls: ['./viewservice.component.css']
})

export class ViewserviceComponent implements OnInit {

  ViewSTB: any = {};
  ViewProduct: any = {};

  form: FormGroup;
  data: any = {};

  formAct = this.fb.group({
    id: [''],
    productname: [''],
    
  })
  
  listproduct = [];
  Layanan = [];
  Services = [];
  Servicelist = [];
  customer = [] ;
  detStb = [] ;
  customerid : number;
  loading_create = false
  alert_failed = false
  alert_success = false
  table_load = false
  table_data = false
  isAct = ""

  constructor(
	  private route: ActivatedRoute,
    private fb: FormBuilder,
	  private router: Router,
	  public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private formBuilder: FormBuilder
  ) {

    this.form = this.formBuilder.group({
      listproduct: new FormArray([], minSelectedCheckboxes(1))
    });

    

   }

  ngOnInit() {
  	this.loadStart();
  }

  loadStart() {
    let id = this.route.snapshot.paramMap.get('id');
  	//alert(id);
  	this.loadCustomer(id);
    this.loadProducts();
  }


  private addCheckboxes() {


    this.ViewProduct.data.map((o, i) => {
      const control = new FormControl(i === 0); // if first item set to true, else false

      (this.form.controls.listproduct as FormArray).push(control);
    });
  }

  isNew(item: any)
  {
    return (item.servicestatus == 0);
  }

  isActive(item: any)
  {
    return (item.servicestatus == 1);
  }

  isNotnew(cust: any)
  {
    let id = cust.customerstatus.id
    console.log(id);
    // if (id = 0) {

    // }
    // let service = '';
    // if ( item.pairingto == null || item.pairingto == 0 ){
    //   return service;
    // }else{
    //   item.customer.services.forEach(function (value) {
    //     service += value.servicename + '\n';
    //   });

    //   return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    // }
  }

  isNotActive(item: any)
  {
    return (item.servicestatus == 2);
  }

  
  /* tambahkan service */
  postService()
  {
    const selectedOrderIds = this.form.value.listproduct
    .map((v, i) => v ? {"productsale_id":this.Layanan[i].id} : null)
      .filter(v => v !== null);
      console.log(selectedOrderIds);

      //this.data = {customer_id : 2, services :  "[{\"productsale_id\":1},{\"productsale_id\":2}]" };

      this.data = {customer_id : this.customerid, services :  JSON.stringify(selectedOrderIds) };

      
    return this.partnerService.PostService(this.data).subscribe((output: any) => {
      console.log(output);
      if (output.status) {
        
        
        this.loading_create = false
        // this.loadServices(this.customerid);
        this.ngOnInit()
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false
      } else {
        
        
        this.loading_create = false
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }
  
    })
  }


  serviceRemoved(s)
  {
    alert('Yakin hapus');
    var service = this.ViewSTB.data.services[s];
    this.partnerService.DeleteService({id:service.id}).subscribe((output: any) => {
      console.log(output['status']);
      if (output['status']){
        this.ViewSTB.data.services.splice(s,1);
      }
    })

    //console.log(service);
  }
  
  serviceActivation(s)
  {

    // if(confirm("Are you sure to delete "+name)) {
    //   console.log("Implement delete functionality here");
    // }else {
    //   console.log("Gagal")
    // }
    var service = this.ViewSTB.data.services[s];
    this.partnerService.ActivationService({
      id:service.id, 
      stb: this.detStb,
      product:service}).subscribe((output: any) => {
    console.log(output);
    
      this.ViewSTB.data.services[s]['servicestatus'] = 1;
      
    })

  }

  serviceNotActivation(s)
  {
    alert('Yakin tidak aktif');
    var service = this.ViewSTB.data.services[s];
    this.partnerService.DeactivationService({id:service.id}).subscribe((output: any) => {
    console.log(output['status']);
      if ( output['status'] ){
        this.ViewSTB.data.services[s]['servicestatus'] = 2;
      }
    })
  }

  onActionclick(act: any, id: any) {
    this.isAct = act;
    return this.partnerService.GetServices(id).subscribe((output: any) => {
      console.log(output.data);
      this.Servicelist = output.data
      // this.formAct.setValue(output.data);
    })
  }

  
  loadCustomer(id: any) {
    this.table_load = true;
    return this.partnerService.GetViewStb(id).subscribe((output: any) => {
      console.log(output);
      this.ViewSTB = output;
      this.customerid = this.ViewSTB.data.customer.id;
      this.customer = this.ViewSTB.data.customer;
      this.Services = this.ViewSTB.data.services;
      this.detStb = this.ViewSTB.data;

      this.table_load = false;
      this.table_data = true;
      this.isNotnew(this.customer);
    })
  }
  
  loadProducts() {
    return this.partnerService.GetProduct('').subscribe((output: any) => {
      console.log(output);
      this.ViewProduct = output;
      this.Layanan = this.ViewProduct.data;
      this.addCheckboxes();
      
    })
  }

  // loadServices(id: any){
    
  //   this.partnerService.GetServices(id).subscribe((output: any) => {
  //     console.log(output);
  //     this.Services = output.data;
  //   })
  // }

  submit() {
    this.postService();
    console.log(this.Layanan);
    console.log(this.form.value.listproduct);
    this.ngOnInit()

  }

}

function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
